import type { GetMeetingQuery } from '@/generated/usermobile-bff/graphql';

export type MeetingRecordingUiState = 'hidden' | 'start_cta';

export type MeetingForRecordingEligibility = Pick<
  GetMeetingQuery['meeting'],
  'status' | 'recording'
>;

export const getMeetingRecordingUiState = (
  meeting: MeetingForRecordingEligibility,
): MeetingRecordingUiState => {
  if (meeting.recording != null) {
    return 'hidden';
  }

  if (meeting.status !== 'SCHEDULED') {
    return 'hidden';
  }

  return 'start_cta';
};
